export const roles = [
  {
    value: "Laboratorista"
  },
  {
    value: "Coordinador"
  },
  {
    value: "Asesor Técnico" 
  }
]

export const techAdvisorRoles = [
  {
    value: "Asesor Técnico" 
  }
]

export const Operativeroles = [
  {
    value: "Laboratorista"
  },
  {
    value: "Coordinador"
  },
]

export const userTypes = [
  {
    value: "Operativo",
  },
  {
    value: "Asesor Técnico",
  },
]

export const mainRequestStatus = [
  {
    id: 'Pendiente de envío',
    value: 'Pendiente de envío',
  },
  {
    id: 'En Espera',
    value: 'Enviar Solicitud',
  },
  // {
  //   id: 'Cancelada',
  //   value: 'Cancelada',
  // },
  {
    id: 'Aceptada',
    value: 'Aceptada',
  },
  // {
  //   id: 'Concluida',
  //   value: 'Concluida',
  // },
  {
    id: 'Rechazada',
    value: 'Rechazada',
  },
]

export const mainRequestStatusFilter = [
  {
    id: 'Pendiente de envío',
    value: 'Pendiente de envío',
  },
  {
    id: 'En Espera',
    value: 'En Espera',
  },
  // {
  //   id: 'Cancelada',
  //   value: 'Cancelada',
  // },
  {
    id: 'Aceptada',
    value: 'Aceptada',
  },
  // {
  //   id: 'Concluida',
  //   value: 'Concluida',
  // },
  {
    id: 'Rechazada',
    value: 'Rechazada',
  },
]

export const mainRequestStatusFiltered = [
  {
    id: 'Cancelada',
    value: 'Cancelada',
  },
  {
    id: 'Concluida',
    value: 'Concluida',
  },
]

export const mainRequestStatusFiltered2 = [
  {
    id: 'Pendiente de envío',
    value: 'Pendiente de envío',
  },
  {
    id: 'En Espera',
    value: 'Enviar Solicitud',
  },
]

export const mainRequestStatusFiltered3 = [
  {
    id: 'Aceptada',
    value: 'Aceptada',
  },
  {
    id: 'Rechazada',
    value: 'Rechazada',
  },
]

export const sampleValidationStatus = [
  {
    id: 'Pendiente',
    value: 'Pendiente',
  },
  {
    id: 'Con defecto',
    value: 'Con defecto',
  },
  {
    id: 'Incompleto',
    value: 'Incompleto',
  },
  {
    id: 'Completo',
    value: 'Completo',
  },
]

export const resultStatus = [
  {
    id: 'Pendiente',
    value: 'Pendiente',
  },
  {
    id: 'Autorizado',
    value: 'Autorizado',
  },
  {
    id: 'Rechazado',
    value: 'Rechazado',
  },
]

export const notificationValidationStatus = [
  {
    id: 'Autorizado',
    value: 'Autorizado',
  },
  {
    id: 'Rechazado',
    value: 'Rechazado',
  },
  {
    id: 'Proceso de validación',
    value: 'Proceso de validación',
  },
  {
    id: 'Solicitud de revisión',
    value: 'Solicitud de revisión',
  }
]

export const labRequestValidationFilter = [
  {
    id: 'Validación de muestras',
    value: 'Validación de muestras',
  },
  {
    id: 'Pruebas de Laboratorio',
    value: 'Pruebas de Laboratorio',
  },
  {
    id: 'Validación de Informes',
    value: 'Validación de Informes',
  },
]

export const requestStatus = [
  {
    id: 'Proceso de Validación',
    value: 'Proceso de Validación',
  },
  {
    id: 'Solicitud de Revisión',
    value: 'Solicitud de Revisión',
  },
  {
    id: 'Pendiente',
    value: 'Pendiente',
  },
  {
    id: "Rechazado",
    value: "Rechazado",
  },
  {
    id: "Autorizado",
    value: "Autorizado",
  }
]

export const surveyStatus = [
  {
    id: 'Pendiente',
    value: 'Pendiente',
  },
  {
    id: 'Bloqueado',
    value: 'Bloqueado',
  },
  {
    id: 'Solicitud de Encuesta',
    value: 'Solicitud de Encuesta',
  },
  {
    id: 'Encuesta Realizada',
    value: 'Encuesta Realizada',
  },
  // {
  //   id: "Concluido",
  //   value: "Concluido",
  // },
]

export const surveyStatusFiltered = [
  {
    id: 'Pendiente',
    value: 'Pendiente',
  },
  {
    id: 'Solicitud de Encuesta',
    value: 'Solicitud de Encuesta',
  },
  // {
  //   id: 'Encuesta Realizada',
  //   value: 'Encuesta Realizada',
  // },
  // {
  //   id: "Concluido",
  //   value: "Concluido",
  // },
]

export const validationProcess = [
  {
    id: 'Solicitud de análisis / Validación de muestras',
    value: 'Validación de muestras',
  },
  {
    id: 'Solicitud de análisis / Validación de ensayos',
    value: 'Validación de ensayos',
  },
  {
    id: 'Solicitud de análisis / Validación de informes parciales',
    value: 'Validación de informes parciales',
  },
  {
    id: "Entrega de resultados",
    value: "Entrega de resultados",
  },
  {
    id: "Encuesta de satisfacción",
    value: "Encuesta de satisfacción",
  },
  {
    id: "Cotizaciones",
    value: "Cotizaciones",
  },
  {
    id: "Envío de solicitud",
    value: "Envío de solicitud",
  },
  {
    id: "Atención de solicitud",
    value: "Atención de solicitud",
  },
]

export const validationProcessFilter = [
  {
    id: "Entrega de resultados",
    value: "Entrega de resultados",
  },
  {
    id: "Encuesta de satisfacción",
    value: "Encuesta de satisfacción",
  },
  {
    id: "Cotizaciones",
    value: "Cotizaciones",
  },
  {
    id: "Envío de solicitud",
    value: "Envío de solicitud",
  },
  {
    id: "Atención de solicitud",
    value: "Atención de solicitud",
  },
]

export const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

export const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Sí
    </div>
  )
}